// extracted by mini-css-extract-plugin
export default {"menu":"Xu3kJlVhASWrrSxhupdM","menuItemWrapper":"sohM5H4C5MvHRrSjv5n5","menuItemChevron":"UnkPmCVktvwfeHElWqrf"};